// @flow

import React from 'react'
import 'react-dates/initialize'
import { DayPickerRangeController } from 'react-dates'
import Range from 'rc-slider/lib/Range'
import TextField from 'components/molecules/SearchTextField'
import CheckboxWrap from 'components/molecules/SearchCheckboxWrap'
import Modal from 'components/shared/Modal'
import Colors from 'components/styles/colors'

import {
  Container,
  Title,
  Description,
  Head,
  Line,
  ContactListItemContainer,
  TwoColumn,
  ThreeColumn,
  ContactListItem,
  Column,
  FormTitle,
  FormTypeWrapper,
  FormType,
  FormTitleText,
  SelectWrapper,
  Select,
  CapacityInput,
  CapacityInputText,
  CapacityInputWrapper,
  SliderInput,
  SliderInputText,
  TextFieldWrapper,
  Textarea,
  CheckboxContainer,
  SendButtonWrapper,
  SendButton,
  FormDescription,
  FormDescriptionEm,
  CheckInOnClickWrapper,
  CheckInOnClickSpace,
  CheckInOnClickButtonWrap,
  CheckInOnClickButton,
} from './styled'

export type PropTypes = {
  ui: {
    eventType: string,
    useType: string,
    capacity: string,
    minPrice: number | string,
    maxPrice: number | string,
    isBudgetUnspecified: boolean,
    isShowCalendar: boolean,
    description: boolean,
    preview: boolean,
  },

  eventTypes: Array<{
    name: string,
    nameText: string,
  }>,

  planDateText: string,

  dayPickerProps: Object,
  budgetRangeProps: Object,

  onClickCalendarContainer: Function,
  onClickApplyCalendar: Function,
  onClickCancelCalendar: Function,

  onChangeEventType: Function,
  onChangeUseType: Function,
  onChangeCapacity: Function,

  onDatesChange: Function,
  onChangePrice: Function,

  onChangeDescription: Function,
  onChangeCheckPreview: Function,

  onClickSend: Function,
  onClickClose: Function,
}

const handleStyle = {
  marginLeft: -10,
  marginTop: -8,
  width: 20,
  height: 20,
  backgroundColor: Colors.blueBdColor,
  borderColor: Colors.blue,
  boxShadow: 'none',
}

const railStyle = {
  height: 2,
  backgroundColor: Colors.gray,
}
const trackStyle = {
  height: 2,
  backgroundColor: Colors.blue,
}
const handleUnspecifiedStyle = {
  marginLeft: -10,
  marginTop: -8,
  width: 20,
  height: 20,
  backgroundColor: Colors.gray,
  borderColor: Colors.gray,
  boxShadow: 'none',
}
const trackUnspecifiedStyle = {
  height: 2,
  backgroundColor: Colors.gray,
}

export default class InquiryModal extends React.Component<*> {
  props: PropTypes

  render() {
    const { props } = this
    const {
      ui,
      planDateText,
      dayPickerProps,
      budgetRangeProps,
      onChangeEventType,
      onChangeUseType,
      onChangeCapacity,
      onClickCalendarContainer,
      onClickApplyCalendar,
      onClickCancelCalendar,
      onChangeDescription,
      onChangeCheckPreview,
      onClickSend,
      onClickClose,
    } = props

    return (
      <Modal onClickClose={onClickClose} isScrollLock>
        <Container>
          <form>
            <Head>
              <Title>{i18n.t('page.room.inquirySpace')}</Title>
              <Description>
                {i18n.t('page.room.inquirySpaceDescription')}
              </Description>
            </Head>
            <Line />
            <div>
              <ul>
                <ContactListItem data-type-width="halfWidth">
                  <ContactListItemContainer className="clearfix">
                    <ThreeColumn>
                      <FormTitle>
                        <FormTypeWrapper>
                          <FormType data-type="required">
                            {i18n.t('page.shared.l_00030')}
                          </FormType>
                        </FormTypeWrapper>
                        <FormTitleText>
                          {i18n.t('page.search.purpose')}
                        </FormTitleText>
                      </FormTitle>
                      <div>
                        <SelectWrapper>
                          <Select
                            onChange={onChangeEventType}
                            value={ui.eventType}
                          >
                            <option selected="" value="" />
                            {props.eventTypes.map((purpose, i) => (
                              <option
                                key={`inquiry_purpose_option_${i}`}
                                value={purpose.name}
                              >
                                {purpose.nameText}
                              </option>
                            ))}
                          </Select>
                        </SelectWrapper>
                      </div>
                    </ThreeColumn>
                    <ThreeColumn>
                      <FormTitle>
                        <FormTypeWrapper>
                          <FormType data-type="required">
                            {i18n.t('page.shared.l_00030')}
                          </FormType>
                        </FormTypeWrapper>
                        <FormTitleText>
                          {i18n.t('page.room.classification')}
                        </FormTitleText>
                      </FormTitle>
                      <div>
                        <SelectWrapper>
                          <Select onChange={onChangeUseType} value={ui.useType}>
                            <option selected="" value="" />
                            <option value="1">
                              {i18n.t('page.room.personalUse')}
                            </option>
                            <option value="2">
                              {i18n.t('page.room.businessUse')}
                            </option>
                          </Select>
                        </SelectWrapper>
                      </div>
                    </ThreeColumn>
                    <ThreeColumn>
                      <FormTitle>
                        <FormTypeWrapper>
                          <FormType data-type="required">
                            {i18n.t('page.shared.l_00030')}
                          </FormType>
                        </FormTypeWrapper>
                        <FormTitleText>
                          {i18n.t('page.search.capacity')}
                        </FormTitleText>
                      </FormTitle>
                      <div>
                        <CapacityInput
                          type="number"
                          onChange={onChangeCapacity}
                          value={ui.capacity}
                        />
                        <CapacityInputText>
                          {i18n.t('page.room.numberOfPeople')}
                        </CapacityInputText>
                      </div>
                    </ThreeColumn>
                  </ContactListItemContainer>
                </ContactListItem>
                <ContactListItem data-type-width="halfWidth">
                  <ContactListItemContainer className="clearfix">
                    <TwoColumn>
                      <FormTitle>
                        <FormTypeWrapper>
                          <FormType>{i18n.t('page.shared.l_00031')}</FormType>
                        </FormTypeWrapper>
                        <FormTitleText>
                          {i18n.t('page.room.planDate')}
                        </FormTitleText>
                      </FormTitle>
                      <TextFieldWrapper>
                        <TextField
                          value={planDateText}
                          label={i18n.t('page.room.selectFromCalendar')}
                          onClick={onClickCalendarContainer}
                          readOnly
                        />
                        {ui.isShowCalendar && (
                          <CheckInOnClickWrapper>
                            <CheckInOnClickSpace>
                              <DayPickerRangeController {...dayPickerProps} />
                              <CheckInOnClickButtonWrap>
                                <CheckInOnClickButton
                                  onClick={onClickCancelCalendar}
                                >
                                  {i18n.t('page.shared.unspecified')}
                                </CheckInOnClickButton>
                                <CheckInOnClickButton
                                  data-button-type="active"
                                  onClick={onClickApplyCalendar}
                                >
                                  {i18n.t('page.search.apply')}
                                </CheckInOnClickButton>
                              </CheckInOnClickButtonWrap>
                            </CheckInOnClickSpace>
                          </CheckInOnClickWrapper>
                        )}
                      </TextFieldWrapper>
                    </TwoColumn>
                  </ContactListItemContainer>
                </ContactListItem>
                <ContactListItem data-type-width="halfWidth">
                  <ContactListItemContainer className="clearfix">
                    <TwoColumn>
                      <FormTitle>
                        <FormTypeWrapper>
                          <FormType>{i18n.t('page.shared.l_00031')}</FormType>
                        </FormTypeWrapper>
                        <FormTitleText>
                          {i18n.t('page.search.budget')}
                        </FormTitleText>
                      </FormTitle>
                      <Range
                        {...budgetRangeProps}
                        railStyle={railStyle}
                        trackStyle={[
                          ui.isShowCalendarisBudgetUnspecified
                            ? trackUnspecifiedStyle
                            : trackStyle,
                        ]}
                        handleStyle={[
                          ui.isBudgetUnspecified
                            ? handleUnspecifiedStyle
                            : handleStyle,
                          ui.isBudgetUnspecified
                            ? handleUnspecifiedStyle
                            : handleStyle,
                        ]}
                      />
                      <CapacityInputWrapper>
                        <SliderInput
                          placeholder={i18n.t(
                            'page.search.budgetStartUnlimited',
                          )}
                          type="number"
                          value={ui.minPrice || ''}
                        />
                        <SliderInputText>
                          {i18n.t('page.search.budgetStartUnit')}
                        </SliderInputText>
                      </CapacityInputWrapper>
                      <CapacityInputWrapper>
                        <SliderInput
                          placeholder={i18n.t('page.search.budgetEndUnlimited')}
                          type="number"
                          value={ui.maxPrice || ''}
                        />
                        <SliderInputText>
                          {i18n.t('page.search.budgetEndUnit')}
                        </SliderInputText>
                      </CapacityInputWrapper>
                    </TwoColumn>
                  </ContactListItemContainer>
                </ContactListItem>
                <ContactListItem>
                  <FormTitle>
                    <FormTypeWrapper>
                      <FormType data-type="required">
                        {i18n.t('page.shared.l_00030')}
                      </FormType>
                    </FormTypeWrapper>
                    <FormTitleText>
                      {i18n.t('page.room.inquirySpaceMatter')}
                    </FormTitleText>
                  </FormTitle>
                  <FormDescription>
                    {i18n.t('page.room.inquirySpaceAttentionInput')}
                  </FormDescription>
                  <FormDescription>
                    {i18n.t('page.room.inquirySpaceAttentionDate')}
                    <FormDescriptionEm href="">
                      {i18n.t('page.room.requestReservation2')}
                    </FormDescriptionEm>
                    {i18n.t('page.room.inquirySpaceAttentionSmooth')}
                  </FormDescription>
                  <div>
                    <Textarea
                      placeholder={i18n.t('page.room.inquirySpaceTextarea')}
                      onChange={onChangeDescription}
                      value={ui.description}
                    />
                  </div>
                </ContactListItem>
                <ContactListItem>
                  <Column>
                    <CheckboxContainer>
                      <CheckboxWrap
                        onChange={onChangeCheckPreview}
                        item={{
                          label: i18n.t('page.room.wishViewing'),
                          id: 'WISH_VIEWING',
                        }}
                        value={ui.preview}
                      />
                    </CheckboxContainer>
                  </Column>
                </ContactListItem>
              </ul>
            </div>
            <SendButtonWrapper>
              <SendButton
                type="submit"
                value={i18n.t('page.room.send')}
                onClick={onClickSend}
              />
            </SendButtonWrapper>
          </form>
        </Container>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/room/InquiryModal/index.jsx